import axios from 'axios';
import { URL_CEP_SERVICE } from '@constants';
import { ZipCodeResponseInterface } from '@interface/cep';

const apiService = axios.create({
  baseURL: URL_CEP_SERVICE,
  timeout: 60000,
});

export function getAddressWithZipCode(
  zipCode: string,
): Promise<ZipCodeResponseInterface['data']> {
  return apiService.get(`${zipCode}/json/`).then((response) => response.data);
}
